import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormSelectorComponent } from './components/form-selector/form-selector.component';
import { HeaderResolver } from '@finra/rampdi-forms-common';
import { InstanceService } from './services/instance.service';
import { NavigationDataService } from './services/navigation-data.service';
import { SchemaService } from './services/schema.service';
import { FipSessionService } from '@finra/fip-session';
import { environment } from '../environments/environment';
import { ErrorRouteComponent } from './components/error-route/error-route.component';
import { AuthorizationGuard } from './guards/authorization.guard';

const routes: Routes = [
  {
    path: 'error',
    data: {
      hasRoutingError: true,
    },
    component: ErrorRouteComponent,
  },
  {
    path: '',
    resolve: {
      instanceData: InstanceService,
    },
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: `view/${environment.identityProviderRealm === 'ews' ? 'dataEntry/section/identifyingInformation' : 'internal/formView/section/all'}`,
      },
      {
        path: 'view/internal/:viewType',
        resolve: {
          schemas: SchemaService,
        },
        runGuardsAndResolvers: 'always',
        children: [
          {
            path: 'section/:sectionId',
            resolve: {
              navData: NavigationDataService, // form/myformtye/view/dataentry/<>
              headerData: HeaderResolver,
            },
            component: FormSelectorComponent,
            runGuardsAndResolvers: 'always',
            canActivate: [FipSessionService],
            data: {
              groups: [],
            },
          },
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'section/identifyingInformation',
          },
        ],
      },
      {
        path: 'view/:viewType',
        resolve: {
          schemas: SchemaService,
        },
        runGuardsAndResolvers: 'always',
        canActivate: [AuthorizationGuard],
        children: [
          {
            path: 'section/:sectionId',
            resolve: {
              navData: NavigationDataService,
              headerData: HeaderResolver,
            },
            component: FormSelectorComponent,
            runGuardsAndResolvers: 'always',
            canActivate: [FipSessionService],
            data: {
              groups: [],
            },
          },
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'section/identifyingInformation',
          },
        ],
      },
    ],
  },
  {
    path: '**',
    redirectTo: `view/${environment.identityProviderRealm === 'ews' ? 'dataEntry/section/full' : 'internal/formView/section/all'}`,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
      scrollOffset: [0, 10],
      paramsInheritanceStrategy: 'always',
      onSameUrlNavigation: 'reload',
      initialNavigation: 'disabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
